import { useSyncExternalStore } from "react";
import { getDrunkConfig, subscribeDrunkConfig, type DrunkConfig } from "./drunk-mode.js";

/** Reaktivní přístup k drunk-mode configu (sdílený store). */
export function useDrunkConfig(): DrunkConfig {
  return useSyncExternalStore(subscribeDrunkConfig, getDrunkConfig, getDrunkConfig);
}
